// extracted by mini-css-extract-plugin
module.exports = {"spacing_large":"Spacing_spacing_large__G8qUO","spacing_small":"Spacing_spacing_small__W265G","spacing_stretch":"Spacing_spacing_stretch__3nSMt","spacing":"Spacing_spacing__IwG3K"};